import i18n from "i18n";
import styles from "./SuccessViewArc.module.scss";
import CheckCircleIcon from "assets/images/rimac-check-circle-filled.svg";

export const SuccessViewArc = ({ numberOrders }) => {
  return (
    <div className={styles["success-view-arc"]}>
      <img src={CheckCircleIcon} alt="Icono de éxito" />
      <h3>{i18n.t("orders.was.successfully.created")} </h3>
      {numberOrders && (
        <>
          <p>{i18n.t("order.number")}</p>
          <ul>
            {numberOrders.map(order => (
              <li>{order}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
